import 'sass/app.scss';

import _ from 'lodash';
import React, { Fragment } from 'react';
import { ToastContainer } from 'react-toastify';
import { FooterLinks } from '../footer/footer-links';
import Footer from '../footer';
import {Link} from 'react-router-dom';
import ArtistListSection from '../artists-list-section.js/artists-list-section';

const TopNav = () => {
    return (
        <div className="topnav-dark grid-x align-spaced">
            <div className="columns small-1 logo-header">
                <a href='/main'><div className="logo-mini med"></div></a>
                <p className="tiny-label">[BETA]</p>
            </div>
            <div className="columns large">
                <nav className="sign-up-nav">
                    <a href="mailto:info@muzado.com">Contact</a>&nbsp;&nbsp;
                    <a href="/login">Login</a>&nbsp;&nbsp;
                    <Link to="/artist-sign-up">
                        <button style={{fontSize: '1em', margin: '0', width: '112px', padding: '0.2rem'}} className="button neo card">
                            <div style={{margin: '2px'}}>Sign Up</div>
                        </button>
                    </Link>
                </nav>
            </div>
        </div>
    );
};

const ArtistBlurb = () => {
    return (
        <div>
            <div style={{position:'relative'}}>
                <div className="artist-splash segment-1">
                </div>
                <div className="splash-container segment-1">
                    <p className="wumbo">Do Music Differently</p>
                    <p className="mini card-blurb">
                        What if your fans could support you directly—and get everything you've ever made in return?<br/><br/>
                        That's Muzado.<br/><br/>
                        Your fans pay $9.99/year for your complete catalog, plus every future release.<br/>
                        You get predictable revenue with full control of the relationship.<br/><br/>
                        No hidden percentages. No surprises. Just you and the people who love your music.<br/>
                        This is what the future of music looks like.
                    </p>
                    <Link to="/artist-sign-up">
                        <button className="button neo card margin-top-3">Join Muzado for Artists</button>
                    </Link>
                </div>
            </div>
        </div>
    )
}

const FanBlurb = () => {
    return (
        <div>
            <div style={{position:'relative'}}>
                <div className="fan-splash segment-1">
                </div>
                <div className="splash-container segment-1">
                    <p className="wumbo">Own Your Music</p>
                    <p className="mini card-blurb">
                        Remember the feeling of owning your favorite album? Muzado brings that back. <br/><br/>
                        Pick an artist you love. Pay $9.99/year. Download their entire catalog and every song they release going forward. Forever.<br/><br/>
                        It's not a rental. It's not a playlist. It's yours—downloaded, owned, kept. And your subscription goes directly to the artist.<br/><br/>
                        This is what music ownership looks like now.
                    </p>
                    <Link to="/fan-sign-up">
                        <button className="button neo card margin-top-3">Create a free account</button>
                    </Link>
                </div>
            </div>
        </div>
    )
}

const FeaturedSection = () => {
    return (
        <div>
            <div className="featured-section segment-1">
                <p className="wumbo">Featured Artists</p>
                <ArtistListSection 
                    sectionLabel={'Test'}
                    artists={[]}
                    key={`plyst-0`}
                />
            </div>
        </div>
    )
}

export class LandingSingle extends React.Component {
    constructor (props) {
        super(props);
    }

    render() {
        return (
            <Fragment>
                <TopNav/>
                <ArtistBlurb/>
                <FanBlurb/>
                {/* <FeaturedSection/> */}
                <Footer/>
            </Fragment>
        )
    }
}